import * as React from 'react'

type ExportToNavButtonProps = {
  href: string
  className?: string
  confirmationMessage?: string
  label?: string
}

const DEFAULT_CONFIRM_TEXT = 'Er du sikker på, at du vil eksportere posten til NAV?'
const DEFAULT_LABEL = 'Export to NAV'

export default function ExportToNavButton({
  href,
  className,
  confirmationMessage = DEFAULT_CONFIRM_TEXT,
  label = DEFAULT_LABEL,
}: ExportToNavButtonProps) {
  const classes = ['btn', 'btn-outline-warning', className].filter(Boolean).join(' ')

  return (
    <a className={classes} href={href} data-method="post" data-confirm={confirmationMessage}>
      {label}
    </a>
  )
}
